import React, { useEffect, useState } from 'react';
import WaveSurferPlayer from '../../components/WaveSurferPlayer/WaveSurferPlayer';//NEW
import FingerprintJS from '@fingerprintjs/fingerprintjs';//NEW
import useEsami from '../../hooks/useEsami';
import { useLocation, useNavigate } from 'react-router-dom';
import useMediaQuery from '../../hooks/useMediaQuery';
import useClassi from '../../hooks/useClassi';
import CustomModal from '../../components/CustomModal/CustomModal';
import ComebackArrow from '../../components/ComebackArrow/ComebackArrow';
import { Button, Card, Row, Col, Badge, Accordion, ListGroup, Spinner, Form, ProgressBar } from 'react-bootstrap';
import CardLoadingPage from '../../components/CardLoadingPage/CardLoadingPage';
import useContenutiUtenti from '../../hooks/useContenutiUtenti';
import { alertService } from '../../services/AlertService';
import useWebSocket from '../../hooks/useWebSocket';
import ProtectedContent from '../../components/ProtectedContent/ProtectedContent';
import useAttestati from '../../hooks/useAttestati';
import audio_policy_test from "../../assets/audio/policy_test.mp3";


const AreaPersonaleCorsoPage = () => {
  const navigate = useNavigate();
  const { loadingStateClassi, getMaterialiClasse } = useClassi();
  const { downloadAttestato, loadingStateAttestati } = useAttestati();
  const isMobile = useMediaQuery('(max-width: 767px)');
  const isTablet = useMediaQuery('(max-width: 991px)');
  const { classe } = useLocation().state || {};
  const [materialiData, setMaterialiData] = useState(null);
  //const { iniziaContenuto, getUrl} = useContenutiUtenti();
  const [loadingContentId, setLoadingContentId] = useState(null);
  const { checkContentStatus, isConnected } = useWebSocket();
  const [selectedContent, setSelectedContent] = useState(null);
  const [attestatoType, setAttestatoType] = useState('verticale'); 
  const [showAllCompletedModal, setShowAllCompletedModal] = useState(false);
  const { getEsamiByClasseAndByToken } = useEsami();
  const [hasExamBooked, setHasExamBooked] = useState(null);
  const [fingerprint, setFingerprint] = useState('');//NEW
  const [showPlayer, setShowPlayer] = useState(false);//NEW
  const [progresso, setProgresso] = useState('');//NEW
  const [showInfoModal, setShowInfoModal] = useState(false);//NEW
  const [statoPagamentoUtente, setStatoPagamentoUtente] = useState('');//NEW

  const [showTempoModal, setShowTempoModal] = useState(false);
  const [showTestModal, setShowTestModal] = useState(false);
  const [tempoRimanenteMinuti, setTempoRimanenteMinuti] = useState(0);

  const { loadingStateContenutiUtenti, iniziaContenuto, verificaStatoContenuto, verificaCompletamenti, getUrl, salvaTest } = useContenutiUtenti();

  const isContenutoOpzionale = (c) => Number(c?.opzionale) === 1;

  /**
   * Corsi senza esame finale in presenza (final_examination = 1): per l’attestato conta anche il test online.
   * Ogni contenuto obbligatorio tipo "test" deve avere esito registrato (id_contenuti_test), oltre a completato.
   */
  const isMandatoryContentFullyDone = (contenuto) => {
    if (isContenutoOpzionale(contenuto)) return true;
    if (!contenuto.completato) return false;
    if (contenuto.tipo_contenuto === 'test') {
      return contenuto.id_contenuti_test != null && contenuto.id_contenuti_test !== undefined;
    }
    return true;
  };

  const allMandatoryRequirementsForAttestato = () => {
    if (!materialiData?.contenuti?.length) return false;
    return materialiData.contenuti.every(isMandatoryContentFullyDone);
  };

/*
  const isBlocked = (contenuto) => {
    // opzionali mai bloccati
    if (contenuto.opzionale === 1) return false;

    // primo contenuto mai bloccato
    if (!contenuto.id_contenuto_propedeutico) return false;

    // trova il padre
    const padre = materialiData.contenuti.find(c => c.id_contenuto === contenuto.id_contenuto_propedeutico);

    // se padre non esiste → blocca per sicurezza
    if (!padre) return true;

    // se non c'è ancora riga per QUESTO contenuto → timer non avviato → blocca
    if (!contenuto.data_fine_prevista) return true;

    // controlla se timer di QUESTO contenuto è scaduto
    const now = Date.now();
    const fine = new Date(contenuto.data_fine_prevista).getTime();
    if (now < fine) return true; // ancora in attesa

    // altrimenti è sbloccato
    return false;
  };
*/

const isBlocked = (contenuto) => {
    // opzionali mai bloccati
    if (isContenutoOpzionale(contenuto)) return false;

    // primo contenuto mai bloccato
    if (!contenuto.id_contenuto_propedeutico) return false;

    // trova il padre
    const padre = materialiData.contenuti.find(c => c.id_contenuto === contenuto.id_contenuto_propedeutico);

    // se padre non esiste → blocca per sicurezza
    if (!padre) return true;

    // se non c'è ancora riga per QUESTO contenuto → timer non avviato → blocca
    // (Questo accade se non hai mai aperto il contenuto padre 240)
    if (!contenuto.data_fine_prevista) return true;

    // --- MODIFICA QUI ---
    // Abbiamo rimosso il controllo (now < fine).
    // In questo modo il contenuto risulta "sbloccato" graficamente, 
    // permettendo all'utente di cliccarci sopra.
    // Sarà poi handleContenutoClick a chiamare il backend che risponderà 
    // con 'tempo_non_trascorso' attivando la modale di attesa.
    
    return false;
  };


  const getAllAreaIds = (areas) => {
    let ids = areas.map(area => String(area.id));
    areas.forEach(area => {
      if (area.sottoaree.length > 0) {
        ids = [...ids, ...getAllAreaIds(area.sottoaree)];
      }
    });
    return ids;
  };

  useEffect(() => {
    if(!classe) {
      navigate("/area-personale/corsi");
      return;
    }
    fetchClassi();
    setStatoPagamentoUtente(classe.stato_pagamento);
  }, [classe]);

  useEffect(() => {
    if (isConnected && classe) {
      checkContentStatus(classe);
      
      const interval = setInterval(() => {
        checkContentStatus(classe.id_classe);
      }, 60000);

      const handleStatusUpdate = (event) => {
        const { contenuti } = event.detail;
        setMaterialiData(prevData => ({
          ...prevData,
          contenuti: contenuti.map(newContenuto => ({
            ...prevData.contenuti.find(c => c.id_contenuto === newContenuto.id_contenuto),
            ...newContenuto,
            opzionale: prevData.contenuti.find(c => c.id_contenuto === newContenuto.id_contenuto)?.opzionale ?? 1
          }))
        }));
      };

      window.addEventListener('contenutiStatusUpdate', handleStatusUpdate);

      return () => {
        clearInterval(interval);
        window.removeEventListener('contenutiStatusUpdate', handleStatusUpdate);
      };
    } else {
      console.log('WebSocket: Non connesso');
    }
  }, [isConnected, classe, checkContentStatus]);

  const fetchClassi = async () => {
    fetchMateriali();
  }

  const fetchMateriali = async () => {
    try {
      const response = await getMaterialiClasse({ id_classe: classe.id_classe, id_classe_utente: classe.id_classe_utente});
      if (!response) {
        console.error("getMaterialiClasse ha restituito undefined/null");
        setProgresso(0);
        setMaterialiData({ contenuti: [] });
        return;
      }
      
      if (response.ore_seguite_corso !== undefined && response.ore_totali_corso !== undefined && response.ore_totali_corso > 0) {
        // Calcola la percentuale basata sulle ore seguite
        let percentuale = Math.round((response.ore_seguite_corso / response.ore_totali_corso) * 100);
        
        // Verifica che tutti i contenuti obbligatori siano completati correttamente
        // Se non tutti i contenuti hanno data_inizio IS NOT NULL e completato = 1, limita a 99%
        if (response.totale_contenuti_obbligatori !== undefined && 
            response.contenuti_completati_correttamente !== undefined &&
            response.contenuti_completati_correttamente < response.totale_contenuti_obbligatori) {
          percentuale = Math.min(99, percentuale); // Limita a 99% se non tutti i contenuti sono completati correttamente
        }
        
        setProgresso(Math.min(100, percentuale));//NEW
      } else {
        setProgresso(0); // Default a 0 se i dati non sono disponibili
      }
      
      // Assicurati che contenuti sia sempre un array
      const materialiDataWithContenuti = {
        ...response,
        contenuti: response.contenuti || []
      };
      
      setMaterialiData(materialiDataWithContenuti);
    } catch (error) {
      console.error("Errore nel caricamento dei materiali:", error);
      setProgresso(0);
      setMaterialiData({ contenuti: [] });
    }
  }

  const checkExamBooking = async () => {
    try {
      // Se il corso NON prevede esame (valore 1), non fare nulla e esci.
      if (materialiData?.final_examination === 1) {
          return; 
      }
      const exams = await getEsamiByClasseAndByToken({ id_classe: classe.id_classe });
      const prenotato = exams?.some(exam => exam.prenotato === 1 || exam.myPrenotation === 1);
      setHasExamBooked(prenotato);
      // 👇 Mostra la modale SOLO se l’utente ha completato tutto e NON ha prenotato
      if (areAllContentsCompleted() && !prenotato) {
        setShowAllCompletedModal(true);
      }
  
    } catch (error) {
      console.error("Errore durante il controllo prenotazione esame:", error);
      setHasExamBooked(false);
  
      // Fallback: mostra modale solo se contenuti completati e nessuna prenotazione nota
      if (areAllContentsCompleted()) {
        setShowAllCompletedModal(true);
      }
    }
  };

  useEffect(() => {
    if (materialiData?.contenuti) {
      checkExamBooking();
    }
  }, [materialiData]);
  
  useEffect(() => {
    // Funzione asincrona per caricare FingerprintJS
    const getFingerprint = async () => {
      // Carica l'agente
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      // Prende l'ID del visitatore
      setFingerprint(result.visitorId);
    };
    getFingerprint();
  }, []);

  //console.log('Fingerprint:', fingerprint);//TODO iniziaContenuto

  const handleInfoIconClick = () => {//NEW
    setShowInfoModal(true);
  };

  const organizeContentByArea = (contenuti) => {
    if (!contenuti) return [];
  
    const sortedContents = [...contenuti].sort((a, b) => a.ordinamento - b.ordinamento);
  
    const areeMap = new Map();
  
    // 1️⃣ Crea tutte le aree (comprese quelle senza contenuti ma che sono padri)
    sortedContents.forEach(contenuto => {
      const areaId = contenuto.id_area;
      const areaPadreId = contenuto.id_area_padre;
  
      if (!areeMap.has(areaId)) {
        areeMap.set(areaId, {
          id: areaId,
          titolo: contenuto.titolo_area,
          id_area_padre: areaPadreId,
          contenuti: [],
          sottoaree: []
        });
      }
  
      // 🔁 Aggiungiamo anche l’area padre se non è ancora stata creata
      if (areaPadreId && areaPadreId !== 0 && !areeMap.has(areaPadreId)) {
        areeMap.set(areaPadreId, {
          id: areaPadreId,
          titolo: contenuto.titolo_padre,
          id_area_padre: 0,
          contenuti: [],
          sottoaree: []
        });
      }
    });
  
    // 2️⃣ Organizza le aree radice e sottoaree
    const areeRadice = [];
    areeMap.forEach(area => {
      if (area.id_area_padre === 0) {
        areeRadice.push(area);
      } else {
        const areaPadre = areeMap.get(area.id_area_padre);
        if (areaPadre) {
          areaPadre.sottoaree.push(area);
        }
      }
    });
  
    // 3️⃣ Assegna i contenuti alla rispettiva area
    sortedContents.forEach(contenuto => {
      const area = areeMap.get(contenuto.id_area);
      if (area) {
        area.contenuti.push(contenuto);
      }
    });
  
    return (
      <Accordion defaultActiveKey={getAllAreaIds(areeRadice)} alwaysOpen>
        {areeRadice.map(area => renderArea(area))}
      </Accordion>
    );
  };

  const countAllContents = (area) => {
    let count = area.contenuti.length;
    if (area.sottoaree && area.sottoaree.length > 0) {
      area.sottoaree.forEach(sotto => {
        count += countAllContents(sotto);
      });
    }
    return count;
  };

  // const organizeContentByArea = (contenuti) => {
  //   if (!contenuti) return [];
    
  //   const sortedContents = [...contenuti].sort((a, b) => a.id_contenuto - b.id_contenuto);
    
  //   const areeMap = new Map();
    
  //   sortedContents.forEach(contenuto => {
  //     if (!areeMap.has(contenuto.id_area)) {
  //       areeMap.set(contenuto.id_area, {
  //         id: contenuto.id_area,
  //         titolo: contenuto.titolo_area,
  //         id_area_padre: contenuto.id_area_padre,
  //         contenuti: [],
  //         sottoaree: []
  //       });
  //     }
  //   });

    
  //   console.log(sortedContents);
    
    
  //   const areeRadice = [];
  //   areeMap.forEach(area => {
  //     if (area.id_area_padre === 0) {
  //       areeRadice.push(area);
  //     } else {
  //       const areaPadre = areeMap.get(area.id_area_padre);
  //       if (areaPadre) {
  //         areaPadre.sottoaree.push(area);
  //       }
  //     }
  //   });

  //   //console.log(areeMap);
  //   // console.log(areeRadice);
  //   // alert("QUIIII");
    
  //   sortedContents.forEach(contenuto => {
  //     const area = areeMap.get(contenuto.id_area);
  //     if (area) {
  //       area.contenuti.push(contenuto);
  //     }
  //   });

  //   return (
  //     <Accordion defaultActiveKey={getAllAreaIds(areeRadice)} alwaysOpen>
  //       {areeRadice.map(area => renderArea(area))}
  //     </Accordion>
  //   );
  // };


  const renderAttestatoSection = () => {
    if (!materialiData?.attestato_disponibile || !allMandatoryRequirementsForAttestato()) return null;

    return (
      <Card className="border-0 shadow-sm mb-4" style={{ backgroundColor: '#f8f9fa' }}>
        <Card.Body className="p-4">
          <div className={`d-flex ${isTablet ? 'flex-column' : 'justify-content-between'} align-items-${isTablet ? 'start' : 'center'}`}>
            <div className={`d-flex align-items-center ${isTablet ? 'mb-4' : ''}`}>
              <div className="me-4">
                <i className="bi bi-trophy-fill text-warning" style={{ fontSize: isMobile ? '2.5rem' : '3rem' }}></i>
              </div>
              <div>
                <h4 className={`mb-2 ${isMobile ? 'fs-5' : ''}`}>Congratulazioni!</h4>
                <p className={`mb-0 text-muted ${isMobile ? 'small' : ''}`}>
                  Hai completato il corso con successo. Puoi scaricare il tuo attestato.
                </p>
              </div>
            </div>
            <div className={`d-flex align-items-center ${isMobile ? 'flex-column w-100' : ''}`}>
              <Form.Select 
                size={isMobile ? "sm" : ""}
                value={attestatoType}
                onChange={(e) => setAttestatoType(e.target.value)}
                className={`${isMobile ? 'w-100 mb-3' : 'me-3'}`}
                style={{ width: isMobile ? '100%' : 'auto' }}
                hidden
              >
                <option value="verticale">Formato Verticale</option>
                <option value="orizzontale">Formato Orizzontale</option>
              </Form.Select>
              <Button 
                variant="primary"
                onClick={() => handleDownloadAttestato()}
                disabled={loadingStateAttestati.isLoadingDownloadAttestato}
                className={isMobile ? 'w-100' : ''}
              >
                {loadingStateAttestati.isLoadingDownloadAttestato ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    Scaricamento...
                  </>
                ) : (
                  <>
                    <i className="bi bi-download me-2"></i>
                    Scarica Attestato
                  </>
                )}
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
    );
  };

  const handleDownloadAttestato = async () => {
    await downloadAttestato({ 
      id_classe_utente: classe.id_classe_utente, 
      tipo_attestato: attestatoType 
    });
  };

  const renderArea = (area, level = 0) => {
    // Se non ci sono né contenuti né sottoaree, non renderizzare
    if (area.contenuti.length === 0 && area.sottoaree.length === 0) return null;
    const HeadingTag = level > 0 ? 'h6' : 'h5';
    return (
      <Accordion.Item 
        key={area.id} 
        eventKey={String(area.id)}
        className={`border-0 opacity-level-${level}`}
      >
        <Accordion.Header>
          <div 
            className="d-flex align-items-center w-100" 
            style={{
              paddingLeft: level > 0 ? `${level * 2.5}rem` : '0',
              position: 'relative'
            }}
          >
            <div className="d-flex align-items-center p-2 rounded-2 flex-grow-1 shadow-sm">
              <i className={`bi ${level > 0 ? 'bi-folder2' : 'bi-journal-text'} text-warning fs-4 me-3`}></i>
              <div>
                <HeadingTag className="mb-0 text-white">{area.titolo}</HeadingTag>
                <small className="text-light mt-1 d-block">
                  {countAllContents(area)} contenut{countAllContents(area) === 1 ? 'o' : 'i'}
                </small>
              </div>
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body className="p-0">
          <ListGroup className="position-relative">
            <div 
              className="position-absolute" 
              style={{
                left: `${level * 2.5 + 1}rem`,
                top: 0,
                bottom: 0,
                width: '2px',
                backgroundColor: '#dee2e6'
              }}
            />
            
            {area.contenuti.map((contenuto, contentIndex) => {
              // const isBlocked = contenuto.id_contenuto_propedeutico ? 
              //                   !materialiData.contenuti.find(
              //                     c => c.id_contenuto === contenuto.id_contenuto_propedeutico
              //                   )?.completato : false;
              return (
                <ListGroup.Item 
                  key={contenuto.id_contenuto}
                  className={`py-3 ${!isBlocked(contenuto) ? 'cursor-pointer hover-light' : ''}`}
                  //disabled={isBlocked}//NEW: commentato per permettere di cliccare su info vincolo temporale
                  style={{
                    position: 'relative',
                    paddingLeft: `${level * 2.5 + 3}rem`,
                    borderBottom: '1px solid rgba(222, 226, 230, 0.8)'
                  }}
                >
                  <div className="d-flex align-items-center">
                    <div className="me-3 d-flex align-items-center justify-content-center" 
                         style={{
                           width: '40px',
                           height: '40px',
                           borderRadius: '8px',
                           background: isBlocked(contenuto) ? '#f8f9fa' : 'rgba(253, 126, 20, 0.1)'
                         }}>
                      {isBlocked(contenuto) ? (
                        <i className="bi bi-lock-fill text-secondary fs-4"></i>
                      ) : (
                        <i className={`bi ${
                          contenuto.tipo_contenuto === 'pdf' ? 'bi-file-pdf text-danger' : 
                          contenuto.tipo_contenuto === 'audio-video' ? 'bi-play-circle-fill text-primary' : 
                          contenuto.tipo_contenuto === 'documento-testo' ? 'bi-file-text text-success' : 
                          contenuto.tipo_contenuto === 'test' ? 'bi-pencil-square text-success' : 
                          'bi-file-text text-info'} fs-4`}></i>
                      )}
                      {isContenutoOpzionale(contenuto) ? (
                        <span className="badge bg-info position-absolute text-white" 
                              style={{
                                top: '3.5rem',
                                fontSize: '0.6rem',
                                whiteSpace: 'nowrap'
                              }}>
                          opzionale
                        </span>
                      ) : (
                        <span className="badge bg-primary position-absolute text-white" 
                              style={{
                                top: '3.5rem',
                                fontSize: '0.6rem',
                                whiteSpace: 'nowrap'
                              }}>
                          {parseFloat(contenuto.peso_orario).toFixed(0)} min
                        </span>
                      )}
                    </div>
                    
                    <div className="flex-grow-1">
                      <h6 className="mb-1">
                        {contentIndex + 1}. {contenuto.titolo}
                      </h6>
                      {isBlocked(contenuto) && contenuto.id_contenuto_propedeutico && (
                        <div className="mt-1">
                          <small className="text-dark">
                            <i className="bi bi-info-circle me-1 text-primary"></i>
                            Per sbloccare questo contenuto devi prima completare:
                            <strong className="ms-1 text-primary">
                              {materialiData.contenuti.find(c => 
                                c.id_contenuto === contenuto.id_contenuto_propedeutico
                              )?.titolo}
                            </strong>
                            <span><i> e attendere il relativo <b>vincolo temporale</b> indicato</i>  </span>
                            <i
                              className="bi bi-info-square-fill me-1 text-primary"
                              style={{ cursor: 'pointer', fontSize: '20px' }}
                              onClick={handleInfoIconClick}
                            />
                          </small>
                        </div>
                      )}
                      {contenuto.tipo_contenuto !== 'test' && contenuto.completato && contenuto.data_inizio && (
                        <small className="text-success d-block fst-italic">
                          <i className="bi bi-check-circle-fill me-1"></i>
                          Contenuto visualizzato il{" "}
                          {new Date(contenuto.data_inizio).toLocaleDateString('it-IT')} alle{" "}
                          {new Date(contenuto.data_inizio).toLocaleTimeString('it-IT', {
                            hour: '2-digit',
                            minute: '2-digit'
                          })}
                        </small>
                      )}
                      {/* {contenuto.tipo_contenuto === 'test' && contenuto.completato && (
                        <small className="text-success d-block">
                          <i className="bi bi-check-circle-fill me-1"></i>
                          Test visualizzato
                        </small>
                      )} */}
                      {contenuto.tipo_contenuto === 'test' && contenuto.completato && (//NEW
                        contenuto.id_contenuti_test != null
                        ?                        
                        <>
                          <small className="text-success d-block">
                            <i className="bi bi-check-circle-fill me-1"></i>
                            Test superato
                            {contenuto.data_fine_prevista && new Date(contenuto.data_fine_prevista) > new Date() && (
                              <>
                              <small className="text-primary">
                                {(() => {
                                  const date = new Date(contenuto.data_fine_prevista);
                                  date.setSeconds(0);
                                  date.setMilliseconds(0);
                                  date.setMinutes(date.getMinutes() + 1);
                                  return ` - Potrai visualizzare il prossimo contenuto alle ${date.toLocaleTimeString('it-IT', {
                                    hour: '2-digit',
                                    minute: '2-digit'
                                  })}`;
                                })()}
                              </small>
                              </>
                            )}
                          </small>
                        </>
                        :
                          <small className="text-dark d-block">
                            <i className="bi bi-info-circle me-1 text-primary"></i>
                            Test non acora superato
                          </small>
                      )}
                    </div>
  
                    {!isBlocked(contenuto) && (
                      <Button 
                        variant="warning"
                        onClick={() => handleContenutoClick(contenuto)}
                        size="sm" 
                        className="rounded-circle"
                        style={{ width: '32px', height: '32px'}}
                      >
                        {loadingContentId === contenuto.id_contenuto ? (
                          <div className="spinner-border spinner-border-sm" role="status">
                            <span className="visually-hidden">Caricamento...</span>
                          </div>
                        ) : (
                          <i className="bi bi-play-fill"></i>
                        )}
                      </Button>
                    )}
                  </div>
                </ListGroup.Item>
              );
            })}
          </ListGroup>
  
          {/* 🔁 Rendi ricorsive anche le sottoaree */}
          {area.sottoaree.length > 0 && (
            <Accordion defaultActiveKey={getAllAreaIds(area.sottoaree)} className="border-0" alwaysOpen>
              {area.sottoaree.map(sottoarea => renderArea(sottoarea, level + 1))}
            </Accordion>
          )}
        </Accordion.Body>
      </Accordion.Item>
    );
  };
  

/*   const calculateProgress = (contenuti) => {
    if (!contenuti?.length) return 0;
    const contenutiObbligatori = contenuti?.filter((contenuto) => !isContenutoOpzionale(contenuto)) || [];
    const totalContenutiObbligatori = contenutiObbligatori.length;
    const contenutiCompletati = contenutiObbligatori.filter(contenuto => contenuto.completato).length;
    
    const totalItems = totalContenutiObbligatori;
    if (totalItems === 0) return 0;
    
    const progressoTotale = contenutiCompletati;
    return Math.round((progressoTotale / totalItems) * 100);
  }; */

  const handleContenutoClick = async (contenuto) => {
    try {
             
      setLoadingContentId(contenuto.id_contenuto);

      // 1️⃣ Chiamata al backend
      const urlResponse = await getUrl({
        id_contenuto: contenuto.id_contenuto,
        id_classe: classe.id_classe,
        fingerprint: fingerprint
      });



      // 2️⃣ Aggiorna sempre la lista dopo la chiamata BE
      await fetchMateriali();

      if (urlResponse.stato === "test non superato") {
        setShowTestModal(true);
        return;
      }

      // 3️⃣ Gestione stati di risposta
      if (urlResponse.stato === "tempo_non_trascorso") {
        const minuti = Math.ceil(urlResponse.tempo_rimanente / 60);
        setTempoRimanenteMinuti(minuti);
        setShowTempoModal(true);
        setLoadingContentId(null);
        return;
      }

      if (urlResponse.stato === "bloccato") {
        alertService.info("Devi prima avviare il contenuto propedeutico.");
        setLoadingContentId(null);
        return;
      }

      if (urlResponse.stato === "ok" || urlResponse.stato === "disponibile") {
        // 4️⃣ Imposta contenuto selezionato per l'apertura

        if (contenuto.tipo_contenuto === 'test') {
          navigate('/test-survey', { 
          state: { 
            classeData: classe,
            selectedContenuto: contenuto
          }
        });
        return;
      }

        setSelectedContent({
          url_contenuto: urlResponse.url,
          tipo_contenuto: contenuto.tipo_contenuto,
          titolo: contenuto.titolo,
          formato_contenuto: urlResponse.formato,
          id_contenuto: contenuto.id_contenuto,
          contenuto: contenuto.contenuto,
        });
      }

    } catch (error) {
      console.error(error);
      alertService.error("Errore apertura contenuto");
    } finally {
      setLoadingContentId(null);
    }
  };




 /*  const progress = calculateProgress(materialiData?.contenuti); */

  const areAllContentsCompleted = () => {
    if (!materialiData?.contenuti || materialiData.contenuti.length === 0) {
      return false;
    }
    return materialiData.contenuti.every(isMandatoryContentFullyDone);
  };

  if(loadingStateClassi.isLoadingMaterialiClasse) {
    return <CardLoadingPage />;
  }

  return (
    <>
      <div className="card custom-card w-100 shadow">
        <div className={`${isMobile ? 'p-0' : 'p-5'}`}>
          <div className='container'>
            <div className='mb-4'>
              <ComebackArrow path={"/area-personale/corsi"} />
            </div>
            {/* Hero Section con immagine */}
            <Card className='border-0 shadow-sm w-100 position-relative overflow-hidden mb-4'>
              <div 
                className="position-absolute w-100 h-100" 
                style={{
                  backgroundImage: `url("${classe?.corso?.immagine_corso || 'default-course-image.jpg'}")`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                }}
              />
              <div 
                className="position-absolute w-100 h-100" 
                style={{
                  background: 'linear-gradient(to bottom, rgba(0,0,0,0.2) 0%, rgba(0,0,0,0.9) 100%)',
                }}
              />
              <Card.Body 
                className="position-relative text-white" 
                style={{ 
                  minHeight: '400px',
                  paddingTop: '3rem',
                  paddingBottom: isMobile ? '4rem' : '8rem',
                  paddingLeft: '3rem',
                  paddingRight: '3rem'
                }}
              >
                <div className="d-flex flex-column h-100">
                  <div>
                    <h2 className={`${isMobile ? 'h3' : 'display-4'} fw-bold mb-3`}>
                      {materialiData?.denominazione_corso}
                    </h2>
                  </div>
                </div>

                <div 
                className="position-absolute start-0"
                style={{ bottom: '2.5rem' }}
              >
                <div className={`d-flex ${isMobile ? 'flex-column' : ''} gap-3 px-4`}>
                  {areAllContentsCompleted() && materialiData?.final_examination !== 1 && (
                    <Button 
                      variant="outline-light"
                      className={`d-flex align-items-center gap-2 px-4 py-2 ${isMobile ? 'w-100' : ''}`}
                      onClick={() => {
                        if (statoPagamentoUtente == 'Parzialmente_pagato') {
                          // Mostra la modale
                          //setShowModalPagamentoIncompleto(true);
                          alert("Il pagamento del corso risulta incompleto! Si prega di contattare l'Amministrazione");
                        } else {
                          // Naviga normalmente
                          navigate(`/area-personale/calendario/esami`, {
                            state: { classeData: classe }
                          });
                        }
                      }}
                    >
                      <i className='bi bi-calendar-check'></i>
                      Calendario Esami
                    </Button>
                  )}
                </div>
              </div>

              </Card.Body>
            </Card>
            {renderAttestatoSection()}
            <Card className='border-0 shadow-sm mb-4' style={{ backgroundColor: '#f8f9fa' }}>
              <Card.Body className="p-4">
                <h4 className='mb-4 d-flex align-items-center text-success'>
                  <i className='bi bi-graph-up me-2'></i>
                  Stato del corso
                </h4>
                <div className="d-flex align-items-center">
                  <div className="flex-grow-1">
                    <ProgressBar 
                      now={progresso}
                      label={`${progresso}%`}
                      striped
                      animated
                      variant={progresso >= 100 ? 'success' : 'primary'}
                      style={{ height: '1rem' }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
{/*             <Row className='g-4 mb-4'>
              <Col xs={12}>
                <Card className='border-0 shadow-sm h-100' style={{ backgroundColor: '#f8f9fa' }}>
                  <Card.Body className="p-4">
                    <h4 className='mb-4 d-flex align-items-center text-success'>
                      <i className='bi bi-graph-up me-2'></i>
                      Progresso del corso
                    </h4>
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <div className="progress" style={{ height: '8px', backgroundColor: '#e9ecef' }}>
                          <div 
                            className="progress-bar bg-success" 
                            role="progressbar" 
                            style={{ width: `${progress}%` }} 
                            aria-valuenow={progress} 
                            aria-valuemin="0" 
                            aria-valuemax="100"
                          />
                        </div>
                      </div>
                      <span className="ms-3 fw-bold text-success">{progress}%</span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row> */}

            {/* Contenuti Section */}
            <Card className='border-0 shadow-sm' style={{ backgroundColor: '#f8f9fa' }}>
              <Card.Body className={`${isMobile ? 'p-0 contenuti-corso-mobile-wrap' : 'p-4'}`}>
                <div className={`d-flex justify-content-between align-items-center mb-4 ${isMobile ? 'flex-column px-3 pt-3' : ''}`}>
                  <div>
                    <h4 className='mb-2'>
                      <i className='bi bi-collection-play text-primary me-2'></i>
                      Contenuti del Corso
                    </h4>
                    <p className="text-muted mb-0">
                      Accedi ai materiali didattici organizzati per area tematica
                    </p>
                  </div>
                  <Badge bg="primary" pill className={`px-3 py-2 ${isMobile ? 'mt-3' : ''}`}>
                    {materialiData?.contenuti?.length || 0} contenuti disponibili
                  </Badge>
                </div>

                {organizeContentByArea(materialiData?.contenuti)}
                {isMobile && (
                  <div className="contenuti-corso-bottom-band" aria-hidden="true" />
                )}
              </Card.Body>
            </Card>
          </div>
        </div>
      </div>
<CustomModal
    show={showTempoModal}
    onHide={() => setShowTempoModal(false)}
    headerText="Tempo non trascorso"
    closeButton={true}
    hideSaveBtn={true}
    btnCancelText="Chiudi"
    onUndoChanges={() => setShowTempoModal(false)}
    body={
      <div className="px-2">
        <p>
          Il contenuto selezionato non è ancora fruibile.<br/>
          Sarà disponibile tra <b>{tempoRimanenteMinuti} minuti</b>.
        </p>
      </div>
    }
/>
<CustomModal
    show={showTestModal}
    onHide={() => setShowTestModal(false)}
    headerText="Test non superato"
    closeButton={true}
    hideSaveBtn={true}
    btnCancelText="Chiudi"
    onUndoChanges={() => setShowTestModal(false)}
    body={
      <div className="px-2">
        <p>
          Il contenuto selezionato non è ancora fruibile.<br/>
          Devi prima superare il test precedente.
        </p>
      </div>
    }
/>
      <CustomModal
        show={showInfoModal}
        onHide={() => setShowInfoModal(false)}
        headerText="Informazioni sul vincolo temporale"
        closeButton={true}
        onUndoChanges={() => setShowInfoModal(false)}
        btnCancelText="Chiudi"
        hideSaveBtn={true}
        onSave={() => setShowInfoModal(false)}
        body={
          <div className="px-2">
            <p>Il contenuto selezionato sarà accessibile solo dopo aver completato il modulo precedente <strong>e aver atteso il tempo minimo indicato</strong>.</p>
            <p><strong>🕒 Questo tempo non è solo un requisito tecnico o amministrativo</strong>:</p>
            <ul>
              <li>ti consente di riflettere su quanto hai appena visto o appreso,</li>
              <li>puoi rivedere passaggi che richiedono maggiore attenzione,</li>
              <li>ti aiuta a consolidare i contenuti prima di procedere.</li>
            </ul>

            <p>📚 In questo modo, il vincolo temporale contribuisce <strong>non solo al monte ore complessivo necessario per la frequenza</strong>, ma anche alla qualità del tuo apprendimento.</p>

            <p class="mb-0">✅ Una volta completato il tempo richiesto, il contenuto successivo sarà automaticamente sbloccato.</p>
          </div>
        }
      />

      {/* Modal per i contenuti protetti */}
      <ProtectedContent
        show={!!selectedContent}
        onHide={() => setSelectedContent(null)}
        selectedContenuto={selectedContent}
      />
      {showAllCompletedModal && !hasExamBooked && (
        <CustomModal
          show={showAllCompletedModal}
          onHide={() => setShowAllCompletedModal(false)}
          headerText="Contenuti completati"
          closeButton={true}
          onUndoChanges={() => setShowAllCompletedModal(false)}
          btnCancelText="Chiudi"
          btnText="Vai al Calendario Esami"
          onSave={() => {
            setShowAllCompletedModal(false);

            if (statoPagamentoUtente == 'Parzialmente_pagato') {
              alert("Il pagamento del corso risulta incompleto! Si prega di contattare l'Amministrazione");
              //setShowModalPagamentoIncompleto(true); // Mostra la modale di avviso
            } else {
              navigate(`/area-personale/calendario/esami`, {
                state: { classeData: classe }
              });
            }
          }}
          body={
            <div className="px-2">
              <p className="text-success fw-bold">
                Hai completato tutti i contenuti del corso. Ora puoi accedere al calendario per prenotare il tuo esame.
              </p>
            </div>
          }
        />
      )}
    </>
  );
};

export default AreaPersonaleCorsoPage;
